import { Component, EventEmitter, Input, Output } from "@angular/core";
import CollapsibleEvent from "../../models/events/collapsible-modal.event";
import DeletableEvent from "../../models/events/deletable-modal.event";

@Component({
  selector: "collapsible-modal-header",
  templateUrl: "collapsible-modal-header.html",
})
export class CollapsibleModalHeaderComponent {
  @Input()
  headerTitle: string = "Default Header";
  @Input()
  controlId: string = "control";
  @Input()
  isOpen: boolean = false;
  @Input()
  deleteIcon: boolean = false;
  @Input()
  disabledDeleteIcon: boolean = false;
  @Input()
  downArrowWhenOpen: boolean = true;

  @Output()
  collapseClicked = new EventEmitter<CollapsibleEvent>();

  @Output()
  deleteClicked = new EventEmitter<DeletableEvent>();

  constructor() {}

  arrowClick() {
    this.isOpen = !this.isOpen;
    if (this.collapseClicked) {
      let e = {
        controlId: this.controlId,
        isOpen: this.isOpen,
      };

      this.collapseClicked.emit(e);
    }
  }

  deleteClick() {
    if (this.deleteClicked) {
      let e = {
        controlId: this.controlId,
      };
      this.deleteClicked.emit(e);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/collapsible-modal-header/collapsible-modal-header.ts